/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var KubeConsumer = /** @class */ (function () {
        function KubeConsumer() {
        }
        KubeConsumer.setReaderComponent = function (reader) {
            if (reader) {
                KubeConsumer._readerComponentFunc = reader;
            }
        };
        KubeConsumer.getReaderComponent = function (props) {
            if (KubeConsumer._readerComponentFunc) {
                return KubeConsumer._readerComponentFunc(props);
            }
            return null;
        };
        return KubeConsumer;
    }());
    function getContentReaderComponent(props) {
        return KubeConsumer.getReaderComponent(props);
    }
    exports.getContentReaderComponent = getContentReaderComponent;
    function setContentReaderComponent(reader) {
        KubeConsumer.setReaderComponent(reader);
    }
    exports.setContentReaderComponent = setContentReaderComponent;
});
